import React from "react";

export default function EditButton({
  disabled = false,
  onEdit,
  label = "Edit",
  editClassName = "fp-ai-btn fp-ai-btn--edit FP_Body",
}) {
  return (
    <>
      <button
        type="button"
        className={editClassName}
        disabled={disabled}
        onClick={onEdit}
      >
        {label}
      </button>
    </>
  );
}
